export const hideTextIcon = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.98633 10.5C2.98633 10.5 5.53633 5.39996 9.99883 5.39996C14.4613 5.39996 17.0113 10.5 17.0113 10.5C17.0113 10.5 14.4613 15.6 9.99883 15.6C5.53633 15.6 2.98633 10.5 2.98633 10.5Z" stroke="black" stroke-width="1.7" stroke-linecap="round"/>
<path d="M9.99883 12.2C10.9377 12.2 11.6988 11.4389 11.6988 10.5C11.6988 9.56113 10.9377 8.80002 9.99883 8.80002C9.05994 8.80002 8.29883 9.56113 8.29883 10.5C8.29883 11.4389 9.05994 12.2 9.99883 12.2Z" fill="#191919"/>
</svg>
`;
